import { Box, Paper, Stack, Typography } from '@mui/material';
import { CounselorDashboard } from '../../types/dashboard';

interface MyFollowUpOverviewCardProps {
  data?: CounselorDashboard['followUpOverview'];
}

/** Counselor Dashboard's "My Follow-up Overview" — total/due-today/overdue/
 * upcoming, scoped to the logged-in Counselor's own leads only. */
export const MyFollowUpOverviewCard = ({ data }: MyFollowUpOverviewCardProps) => {
  const rows = [
    { label: 'Total follow-ups', value: data?.total ?? 0, color: 'primary.main' },
    { label: 'Due today', value: data?.dueToday ?? 0, color: 'warning.main' },
    { label: 'Overdue', value: data?.overdue ?? 0, color: 'error.main' },
    { label: 'Upcoming', value: data?.upcoming ?? 0, color: 'info.main' },
  ];

  return (
    <Paper sx={{ p: 2, height: '100%' }}>
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        My Follow-up Overview
      </Typography>
      <Stack direction="row" flexWrap="wrap" gap={3}>
        {rows.map((row) => (
          <Box key={row.label}>
            <Typography variant="h5" sx={{ fontWeight: 700, color: row.color }}>
              {row.value}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {row.label}
            </Typography>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
};
